module.exports = __webpack_public_path__ + "GU.svg?753ae3b4e743bf80bd27041aa667e4c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/GU.svg
// module id = 61
// module chunks = 0